/**
 * External Service Constants
 * Centralized constants for external API services and URLs
 */

export const EXTERNAL_SERVICES = {
  GEOCODING: {
    API_URL: 'https://nominatim.openstreetmap.org/search',
    CACHE_EXPIRY_MS: 1000 * 60 * 60 * 24, // 24 hours
    DEBOUNCE_DELAY_MS: 300, // 300ms
  },
  MAPS: {
    CARTO_DB_TILES:
      'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}{r}.png',
    OPENSTREETMAP_TILES: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  },
}
